import { scaleValue } from "../../../../utils/scaleValue";

// export const data = [
//   {
//     name: "Jan",
//     uv: 0,
//     pv: 0,
//     amt: 0,
//   },
//   {
//     name: "Feb",
//     uv: 0,
//     pv: 0,
//     amt: 0,
//   },
//   {
//     name: "Mar",
//     uv: 0,
//     pv: 0,
//     amt: 0,
//   },
//   {
//     name: "Apr",
//     uv: 0,
//     pv: 0,
//     amt: 0,
//   },
//   {
//     name: "May",
//     uv: 0,
//     pv: 0,
//     amt: 0,
//   },
//   {
//     name: "Jun",
//     uv: 0,
//     pv: 0,
//     amt: 0,
//   },
//   {
//     name: "Jul",
//     uv: 0,
//     pv: 0,
//     amt: 0,
//   },
//   {
//     name: "Aug",
//     uv: 0,
//     pv: 0,
//     amt: 0,
//   },
//   {
//     name: "Sept",
//     uv: 0,
//     pv: 0,
//     amt: 0,
//   },
//   {
//     name: "Oct",
//     uv: 0,
//     pv: 0,
//     amt: 0,
//   },
//   {
//     name: "Nov",
//     uv: 0,
//     pv: 0,
//     amt: 0,
//   },
//   {
//     name: "Dec",
//     uv: 0,
//     pv: 0,
//     amt: 0,
//   },
// ];

export const data = [
  { name: "Jan", inflow: 120, outflow: 110 },
  { name: "Feb", inflow: 200, outflow: 220 },
  { name: "Mar", inflow: 150, outflow: 130 },
  { name: "Apr", inflow: 180, outflow: 160 },
  { name: "May", inflow: 220, outflow: 240 },
  { name: "Jun", inflow: 190, outflow: 170 },
  { name: "Jul", inflow: 210, outflow: 200 },
  { name: "Aug", inflow: 12000, outflow: 18000 }, // Example with higher values
  { name: "Sep", inflow: 160, outflow: 150 },
  { name: "Oct", inflow: 170, outflow: 160 },
  { name: "Nov", inflow: 230, outflow: 240 },
  { name: "Dec", inflow: 250, outflow: 220 },
];
export interface Transaction {
  id: string;
  paymentLinkId: string;
  productId: string;
  organizationId: string;
  quantity: number;
  price: number;
  amount: number;
  type: string;
  paymentFrom: string;
  payerEmail: string;
  productName: string;
  currency: string;
  status: string;
  createdAt: string;
  updatedAt: string;
  reference: string;
  meta: Record<string, any>;
}

export const transactionData: Transaction[] = [
  {
    id: "534361cc-0368-49c6-ac96-df0c3a61b879",
    paymentLinkId: "1bd71639-97de-4b93-bf9c-bafad7d07d5c",
    productId: "",
    organizationId: "79a47019-c402-4c6b-955e-b7285cdc7737",
    quantity: 1,
    price: 10,
    amount: 10,
    type: "card",
    paymentFrom: "rene",
    payerEmail: "rene@gmail.com",
    productName: "Custom amount",
    currency: "USD",
    status: "pending",
    createdAt: "1692048600000", // August 15, 2023
    updatedAt: "1692048600000",
    reference: "pi_3PvE68Aru3tyqTLa0bkCfDBS",
    meta: {},
  },
  {
    id: "756e1ccc-9e2f-48bc-bb9a-c89a76a7b278",
    paymentLinkId: "7ed13a6a-9d26-4236-bd85-72f6beaf0b39",
    productId: "",
    organizationId: "f19c55c3-cb67-4f96-bda8-9e8f4c6a2519",
    quantity: 1,
    price: 50,
    amount: 50,
    type: "card",
    paymentFrom: "sarah",
    payerEmail: "sarah@gmail.com",
    productName: "Custom amount",
    currency: "USD",
    status: "completed",
    createdAt: "1689379200000", // July 15, 2023
    updatedAt: "1689379200000",
    reference: "pi_5NvS78Bas3ufpQRc7vM0kQCS",
    meta: {},
  },
  {
    id: "8abf4bd6-c9c5-4763-8c27-f83f918f678e",
    paymentLinkId: "5ed26a7a-6d25-4346-ad23-bb19be207c89",
    productId: "",
    organizationId: "c27a44b6-94b7-4f6c-8f92-fb8fc0e57243",
    quantity: 1,
    price: 20,
    amount: 20,
    type: "card",
    paymentFrom: "john",
    payerEmail: "john@gmail.com",
    productName: "Custom amount",
    currency: "USD",
    status: "pending",
    createdAt: "1677628800000", // February 28, 2023
    updatedAt: "1677628800000",
    reference: "pi_2QgE98Ber6bfyPTe5yLpSfFB",
    meta: {},
  },
  {
    id: "1afbd536-88b3-4eaa-8f69-a8149621763d",
    paymentLinkId: "3db72a4c-7d72-42bd-bc35-01ebff102df9",
    productId: "",
    organizationId: "e7a55007-89b6-4b8d-98d8-78fbbfb8de97",
    quantity: 1,
    price: 100,
    amount: 100,
    type: "card",
    paymentFrom: "alex",
    payerEmail: "alex@gmail.com",
    productName: "Custom amount",
    currency: "USD",
    status: "completed",
    createdAt: "1669852800000", // December 1, 2022
    updatedAt: "1669852800000",
    reference: "pi_9RvG67Bas3tfpQCd9uN8kLS",
    meta: {},
  },
  {
    id: "cc33b62e-3456-4a5c-8e93-aabb8d8efb22",
    paymentLinkId: "9dcf5b33-073a-4e2a-92b5-ccdf36b4bb88",
    productId: "",
    organizationId: "b4d8f7cb-57d5-4b6a-865e-6379dfb5e3cb",
    quantity: 2,
    price: 30,
    amount: 60,
    type: "card",
    paymentFrom: "mike",
    payerEmail: "mike@gmail.com",
    productName: "Custom amount",
    currency: "USD",
    status: "completed",
    createdAt: "1672454400000", // January 1, 2023
    updatedAt: "1672454400000",
    reference: "pi_4HvG78Bas7tfpQCd5bL3pYQS",
    meta: {},
  },
  {
    id: "b3d5e2de-5d5b-4f8a-a9cb-79f5c5a6b97f",
    paymentLinkId: "2bf0d4f8-7429-4dfc-9b5d-fc3f5bb8e379",
    productId: "",
    organizationId: "c5a4c46d-2e9b-43d1-b8f4-15bbf2c7e82d",
    quantity: 3,
    price: 70,
    amount: 210,
    type: "card",
    paymentFrom: "anna",
    payerEmail: "anna@gmail.com",
    productName: "Custom amount",
    currency: "USD",
    status: "completed",
    createdAt: "1701312000000", // November 30, 2023
    updatedAt: "1701312000000",
    reference: "pi_2HtD69Sas3ufqTDe4oLpKpLS",
    meta: {},
  },
  {
    id: "f5b6c3d1-d22c-4bf3-a3a6-4177a5bb423e",
    paymentLinkId: "0bf6b2e9-8d3a-42d8-936f-3e5a5bfc2a64",
    productId: "",
    organizationId: "d1b2c78d-b1b6-4e28-8e8f-25b9f2f6d7a3",
    quantity: 4,
    price: 40,
    amount: 160,
    type: "card",
    paymentFrom: "steve",
    payerEmail: "steve@gmail.com",
    productName: "Custom amount",
    currency: "USD",
    status: "pending",
    createdAt: "1719868800000", // July 1, 2024
    updatedAt: "1719868800000",
    reference: "pi_5HtE69Bas7ufrTQe7cMpKfYS",
    meta: {},
  },
  {
    id: "bd5f632f-e7a7-4917-b9a7-564f6d0a6d4b",
    paymentLinkId: "1bf7d6e2-3b8a-4fdb-a4c7-2a5a5f9a8e93",
    productId: "",
    organizationId: "e7f6d78d-d4a8-4e7c-a9f4-25b5c2c6f9a7",
    quantity: 1,
    price: 20,
    amount: 20,
    type: "card",
    paymentFrom: "jane",
    payerEmail: "jane@gmail.com",
    productName: "Custom amount",
    currency: "USD",
    status: "completed",
    createdAt: "1706486400000", // January 1, 2024
    updatedAt: "1706486400000",
    reference: "pi_6NtD79Bfs9sfqTDe8pLqYrDS",
    meta: {},
  },
];
